module.exports = __webpack_public_path__ + "static/AxaColpatria1-947ec20c35c8b629fbbda2fd82c98cd6.png";